import { render, staticRenderFns } from "./ChildForm.vue?vue&type=template&id=186e25a8&scoped=true&"
import script from "./ChildForm.vue?vue&type=script&lang=js&"
export * from "./ChildForm.vue?vue&type=script&lang=js&"
import style0 from "./ChildForm.vue?vue&type=style&index=0&id=186e25a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e25a8",
  null
  
)

export default component.exports